<template>
  <tbody class="item-tab">
    <tr>
      <td class="border-t-2 border-gray-300 px-3" rowspan="2">
        <label class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
          <input type="checkbox" :id="order.order._id" class="form-checkbox rowCheckbox focus:outline-none focus:shadow-outline" @click="getRowDetail($event, order, order.order._id)"
          />
        </label>
      </td>

      <td class="border-t-2 border-r-2 border-l-2 border-gray-300">
        <!--sous table order -->
        <div class="mb-2 align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard px-4 pt-2 rounded-bl-lg rounded-br-lg" >
          <table class="min-w-full">
            <thead>
              <tr>
                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-primary-600 tracking-wider">
                  ID order
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-primary-600 tracking-wider" >
                  {{ $t('traking_number') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-primary-600 tracking-wider" >
                  {{ $t('city') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-primary-600 tracking-wider" >
                  {{ $t('details') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-primary-600 tracking-wider" >
                  {{ $t('status') }}
                </th>

                <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-primary-600 tracking-wider" >
                  {{ $t('total_price') }}
                </th>

              </tr>
            </thead>

            <tbody class="bg-white">
              <tr>
                <td class="px-3 py-2 whitespace-no-wrap">
                  <div class="flex items-center">
                    <div>
                      <div class="text-sm leading-5 text-gray-800">
                        {{ order.order.id }}
                      </div>
                    </div>
                  </div>
                </td>

                <td class="px-3 py-2 whitespace-no-wrap">
                  <div class="text-sm leading-5 siz12 text-orange-900">
                    {{ order.trackingNumber }}
                  </div>
                </td>

                <td class="px-3 py-2 whitespace-no-wrap">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ order.order.customer.city }}
                  </div>
                </td>

                <td class="px-3 py-2 whitespace-no-wrap 0">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ TotalProductOrder() }} {{ $t('products') }}
                  </div>
                </td>

                <td class="px-3 py-2 whitespace-no-wrap text-center">
                  <div :class="order.status == 'delivered' ? 'bg-primary-600' : 'bg-orange-600'" class="text-sm leading-5 px-2 rounded-full text-xs text-white cursor-pointer font-medium">
                    {{ order.status }}
                  </div>
                </td>

                <td class="px-3 py-2 text-right whitespace-no-wrap">
                  <div class="text-sm leading-5 text-orange-900">
                    {{ order.orderObjet.totalPrice }}
                    <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                    <span v-if="order.type == 'return'" class="font-bold">(Returned)</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- end sous table order -->
      </td>

      <template v-if="global_vat > 0">
        <td class="border-t-2 border-gray-300 border-r-2">
          <input id="global_vat" disabled type="number" min="0" @input="changedVat" v-model="global_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
  
        <td v-if="servicesSeller.confirmation" :class="!order.orderObjet.is_confirmed ? 'empty-row' : ''"  class="border-t-2 border-gray-300 border-r-2">
          <input v-if="order.orderObjet.is_confirmed" id="confirmation" disabled type="number" min="0" @input="changedVat" v-model="confirmation_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
      </template>

      <template v-else>

        <td class="border-t-2 border-gray-300 border-r-2">
          <input id="upsell_vat" disabled type="text" min="0" @input="changedVat" :value="upsell_vat" class="py-2 border-2 border-gray-400 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
        </td>

        <td class="border-t-2 border-gray-300 border-r-2">
          <input id="quality_control" disabled type="number" min="0" @input="changedVat" v-model="quality_control" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>

        <td v-if="servicesSeller.confirmation" class="border-t-2 border-gray-300 border-r-2">
          <input id="confirmation" disabled type="number" min="0" @input="changedVat" v-model="confirmation_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
  
        <td v-if="servicesSeller.fulfillement" class="border-t-2 border-gray-300 border-r-2">
          <input id="confirmation" disabled type="number" min="0" @input="changedVat" v-model="fulfillement_fees_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
  
        <td v-if="servicesSeller.shipping" :class="shipping_vat != 0 ? '' : 'empty-row'" class="border-t-2 border-gray-300 border-r-2">
          <input id="shipping_fees" disabled v-if="shipping_vat != 0" type="number" min="0" @input="changedVat" v-model="shipping_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
  
        <td v-if="servicesSeller.shipping" :class="order.status == 'refused' ? '' : 'empty-row'" class="border-t-2 border-gray-300 border-r-2">
          <input v-if="order.status == 'refused'" disabled id="refund" type="number" min="0" @input="changedVat" v-model="shipping_refund_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
  
        <td v-if="servicesSeller.shipping" :class="order.status == 'cancelled' ? '' : 'empty-row'" class="border-t-2 border-gray-300">
          <input v-if="order.status == 'cancelled'" disabled id="Cancelled" type="number" min="0" @input="changedVat" v-model="shipping_cancel_vat" class="py-2 border-2 border-gray-400 border-opacity-100 text-xs px-2 outline-none block h-full w-full"/>
        </td>
      </template>
    </tr>
    <tr>
      <td class="border-t-2 border-l-2 border-r-2 border-gray-300 px-4 text-right" >
        <div class="text-base font-bold leading-5 text-orange-900">
          {{ $t('revenue') }}:
          <span class="text-primary-600">{{ TotalAmont() }}
            <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup></span>
        </div>
      </td>

      <td class="px-4 py-2 whitespace-no-wrap border-t-2 text-right" colspan="7">
        <div class="text-base font-bold leading-5 text-orange-900">
          {{ $t('total_fees') }}:
          <span class="text-primary-600" >{{ totalfees }}
            <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup></span>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    item: Object,
    formData: { type: Object },
    confvat: Number,
    fulvat: Number,
    ship_vat: [Array, Number],
    def_ship_vat: Number,
    ship_refund_vat: Number,
    ship_cancel_vat: Number,
    qu_control: Number,
    citiesPrices: { type: Array },
    cuurency: String,
    warehouse: String,
    servicesSeller: { type: Object },
    idWharhouse: { type: Object },
    gl_vat: Number,
    upsellvat: Number,
    isconf_vat: Number,
  },
  data: function() {
    return {
      order: this.item,
      totalfees: 0,
      shippings: [],
      shippingType: 'normal',
      shippingTypeChangCount: 1,
      confirmation_vat: this.confvat,
      fulfillement_fees_vat: this.fulvat,
      shipping_vat: this.ship_vat,
      default_shipping_vat: this.def_ship_vat,
      shipping_refund_vat: this.ship_refund_vat,
      shipping_cancel_vat: this.ship_cancel_vat,
      quality_control: this.qu_control,
      global_vat: this.gl_vat,
      upsell_vat: this.upsellvat,
      is_conf_vat: this.isconf_vat
    };
  },
  async mounted() {
    const filters = {};
    this.OrderAddfees();
  },
  watch: {
    ship_vat: function() {
      this.shipping_vat = this.ship_vat;
      this.confirmation_vat = this.confvat;
      this.fulfillement_fees_vat = this.fulvat;
      this.shipping_refund_vat = this.ship_refund_vat;
      this.shipping_cancel_vat = this.ship_cancel_vat;
      this.quality_control = this.qu_control;
      this.global_vat = this.gl_vat;
      this.is_conf_vat = isconf_vat;
      this.OrderAddfees();
    },
  },
  methods: {
    TotalProductOrder() {
      let totalProduct = 0;
      if (this.order.order.details.length > 0) {
        for (let p = 0; p < this.order.order.details.length; p++) {
          totalProduct += this.order.order.details[p].quantity;
        }
      }
      
      return totalProduct;
    },
    changedVat(event) {
      this.$emit(
        'UpdateRowFees',
        this.order.order._id,
        this.confirmation_vat,
        this.fulfillement_fees_vat,
        this.shipping_vat,
        this.shipping_refund_vat,
        this.shipping_cancel_vat,
        this.quality_control,
        this.upsell_vat,
        this.global_vat,
        this.TotalAmont(),
      );
      this.OrderAddfees();
    },
    exceptText(text) {
      if (text && text.length > 40) text = text.substring(0, 40) + '...';
      return text;
    },
    getRowDetail: function($event, order, id) {
      this.$emit('getRowDetail', $event, order, id);
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    getPriceBycity(city, array) {
      let price = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].name.toLowerCase() === city.toLowerCase()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    getPriceByZone(zone, array) {
      let price = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].zone.toString() === zone.toString()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    getIDBycity(city, array) {
      let zone = null;
      for (var i = 0; i < array.length; i++) {
        if (array[i].name.toLowerCase() === city.toLowerCase()) {
          zone = array[i].zone;
          break;
        }
      }
      return zone;
    },

    TotalAmont: function() {
      return parseFloat(this.order.orderObjet.totalPrice) - this.totalfees;
    },
    async OrderAddfees() {
      if (this.order.orderObjet.is_confirmed) {
        this.confirmation_vat = this.is_conf_vat;
      } else if(this.global_vat > 0) {
        this.confirmation_vat = 0;
      }

      this.order.order.confirmation_vat = this.confirmation_vat;
      this.order.order.fulfillement_fees_vat = this.fulfillement_fees_vat;

      const services = this.getElementInArray( this.order.seller.settings, this.idWharhouse._id );

      if (this.idWharhouse && this.idWharhouse.country && services && services.shipping) {
        if (this.order.orderObjet.customer.city) {
        } else {
          this.shipping_vat = 0;
        }
      }

      if (this.order.type === 'return') {
        this.shipping_vat = 0;
        this.confirmation_vat = 0;
        this.fulfillement_fees_vat = 0;
      }

      this.order.order.shipping_vat = this.shipping_vat;
      this.order.order.confirmation_vat = this.confirmation_vat;

      this.order.order.fulfillement_fees_vat = this.fulfillement_fees_vat;
      this.order.order.quality_control = this.quality_control;

      this.order.order.upsell_vat = this.upsell_vat;
      this.order.order.global_vat = this.global_vat;

      this.order.order.is_conf_vat = this.is_conf_vat;

      if (this.order.type === 'return' && this.order.status === 'refused' && services && services.shipping) {
        this.order.order.shipping_refund_vat = this.shipping_refund_vat;
      } else {
        this.shipping_refund_vat = this.order.order.shipping_refund_vat = 0;
      }

      if ( this.order.type === 'return' && this.order.status === 'cancelled' && services && services.shipping) {
        this.shipping_cancel_vat = this.shipping_cancel_vat;
        this.order.order.shipping_cancel_vat = this.shipping_cancel_vat;
      } else {
        this.shipping_cancel_vat = this.order.order.shipping_cancel_vat = 0;
      }

      // Check Upsel Order
      const upselOrder = this.order.order.upsel ? JSON.parse(this.order.order.upsel) : false;

      if (!upselOrder) {
        this.upsell_vat = 0;
      }

      this.order.order.upsell_vat = this.upsell_vat;

      if(this.global_vat > 0) {
        this.totalfees = Number.parseFloat(this.global_vat) + Number.parseFloat(this.confirmation_vat);
      } else {
        this.totalfees =
          Number.parseFloat(this.confirmation_vat) +
          Number.parseFloat(this.fulfillement_fees_vat) +
          Number.parseFloat(this.shipping_vat) +
          Number.parseFloat(this.shipping_refund_vat) +
          Number.parseFloat(this.shipping_cancel_vat) +
          Number.parseFloat(this.quality_control) +
          (upselOrder ? Number.parseFloat(this.upsell_vat) : 0);
      }
    },
    formattedDate(date) {
      return this.$moment(date).format('yyyy-MM-DD');
    },
  },
};
</script>
